// ViewReview.jsx
import React, { useState, useEffect } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { ViewReviewsDetail } from "../../services/reviews";
import DetailedReviewView from "./DetailedReviewView";
import ShortReviewView from "./ShortReviewView";
import BlogReviewView from "./BlogReviewView";

const ViewReview = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { reviewId } = useParams();

  const [reviewData, setReviewData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [determinedReviewType, setDeterminedReviewType] = useState(null);

  // First priority: reviewType from location state
  const reviewTypeFromLocation = location.state?.reviewType;

  useEffect(() => {
    const fetchReviewData = async () => {
      setLoading(true);
      try {
        const response = await ViewReviewsDetail(reviewId);

        if (response?.data?.statusCode === 200) {
          setReviewData(response.data.result);

          console.log(reviewData);

          // If reviewType wasn't passed in location.state, determine it from API response
          if (!reviewTypeFromLocation) {
            setDeterminedReviewType(response.data.result.review_type);
          }
        } else {
          setError("Failed to fetch review details");
        }
      } catch (error) {
        setError("An error occurred while fetching review details");
      } finally {
        setLoading(false);
      }
    };

    fetchReviewData();
  }, [reviewId, reviewTypeFromLocation]);

  if (loading) return <div className="loading-overlay">Loading...</div>;
  if (error) return <div className="error-container">{error}</div>;
  if (!reviewData) return <div>No review data found</div>;

  // Determine which review type to use (location state takes priority)
  const activeReviewType = reviewTypeFromLocation || determinedReviewType;

  // Determine which component to render based on review type
  const renderReviewComponent = () => {
    switch (activeReviewType) {
      case "detail":
        return <DetailedReviewView reviewData={reviewData} />;
      case "blog":
        return <BlogReviewView reviewData={reviewData} />;
      case "short":
        return <ShortReviewView reviewData={reviewData} />;
      default:
        return <div>Unknown review type: {activeReviewType}</div>;
    }
  };

  return (
    <div className="review-container">
      {/* <button onClick={() => navigate(-1)} className="back-button">
        ← Back
      </button> */}

      {renderReviewComponent()}
    </div>
  );
};

export default ViewReview;
